import { Moment } from '~/types'
import { Transaction, SORT_TYPE, Card, Page } from '~/biz/store/cards/types'

export type Filters = {
  sort?: SORT_TYPE
  [key: string]: string | number | boolean | Moment | undefined | null
}

export type TabValues = {
  [TAB_KEY.TRANSACTIONS]: {
    isTxnLoading: boolean
    transactions: Transaction[]
    totalCount: number
    page: Page
    filters: Filters
  }
  [TAB_KEY.STATUS_LOGS]: {
    isTxnLoading: boolean
    statusLogs: StatusLog[]
    totalCount: number
    page: Page
    filters: Filters
  }
  [TAB_KEY.CUSTOMER_CARDS]: {
    isTxnLoading: boolean
    cards: Card[]
    totalCount: number
    page: Page
    filters: Filters
  }
}

export type StatusLog = {
  createdAt: string | Moment
  logId: string
  event: StatusLogEvent
  note: string
}

export type CardSpending = {
  amount: string
  cardOpaqueId: string
  currency: string
  velocityWindow: string
}

export enum CARD_DETAILS_ACTIONS {
  SET_FILTERS = 'CARD_DETAILS_ACTIONS.SET_FILTERS',
  SET_PAGE = 'CARD_DETAILS_ACTIONS.SET_PAGE',
  SET_TOTAL_COUNT = 'CARD_DETAILS_ACTIONS.SET_TOTAL_COUNT',
  SWITCH_TAB = 'CARD_DETAILS_ACTIONS.SWITCH_TAB',
  SET_IS_TXN_LOADING = 'CARD_DETAILS_ACTIONS.SET_IS_TXN_LOADING',
  SET_TRANSACTIONS = 'CARD_DETAILS_ACTIONS.SET_TRANSACTIONS',
  SET_STATUS_LOGS = 'CARD_DETAILS_ACTIONS.SET_STATUS_LOGS',
  SET_CUSTOMER_CARDS = 'CARD_DETAILS_ACTIONS.SET_CUSTOMER_CARDS',
}

export enum TAB_KEY {
  TRANSACTIONS = 'Transactions',
  STATUS_LOGS = 'Status Logs',
  CUSTOMER_CARDS = 'Customer Cards',
}

export type StatusLogEvent =
  | 'activate'
  | 'block_by_fraud'
  | 'close'
  | 'create'
  | 'inactive'
  | 'lost'
  | 'pin_change'
  | 'pin_reset'
  | 'pin_setup'
  | 'reissue'
  | 'stolen'
  | 'suspend'

type SetFilters = {
  type: typeof CARD_DETAILS_ACTIONS.SET_FILTERS
  filters: Filters
}

type SetPage = {
  type: typeof CARD_DETAILS_ACTIONS.SET_PAGE
  page: Page
}

type SetTotalCount = {
  type: typeof CARD_DETAILS_ACTIONS.SET_TOTAL_COUNT
  totalCount: number
}

type SwitchTab = {
  type: typeof CARD_DETAILS_ACTIONS.SWITCH_TAB
  tabKey: TAB_KEY
}

type SetIsTxnLoading = {
  type: typeof CARD_DETAILS_ACTIONS.SET_IS_TXN_LOADING
  isTxnLoading: boolean
}

type SetTransactions = {
  type: typeof CARD_DETAILS_ACTIONS.SET_TRANSACTIONS
  transactions: Transaction[]
}

type SetStatusLog = {
  type: typeof CARD_DETAILS_ACTIONS.SET_STATUS_LOGS
  statusLogs: StatusLog[]
}

type SetCustomerCards = {
  type: typeof CARD_DETAILS_ACTIONS.SET_CUSTOMER_CARDS
  cards: Card[]
}

export type ActionTypes =
  | SetFilters
  | SetPage
  | SetTotalCount
  | SwitchTab
  | SetIsTxnLoading
  | SetTransactions
  | SetStatusLog
  | SetCustomerCards
